import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Home.css';

// Donnees des clients reels avec screenshots locaux
const realClients = [
  {
    id: 1,
    name: 'Keslla Coiffure',
    slug: 'keslla-coiffure',
    category: 'Coiffure',
    url: 'https://keslla-coiffure.e-application.fr',
    screenshot: '/screenshots/keslla.png',
    description: 'Salon de coiffure moderne avec reservation en ligne',
    result: '+40% reservations'
  },
  {
    id: 2,
    name: 'Le Bac Paris',
    slug: 'le-bac-paris',
    category: 'Restaurant',
    url: 'https://le-bac-paris.e-application.fr',
    screenshot: '/screenshots/le-bac-paris.png?v=2',
    description: 'Restaurant parisien avec carte digitale',
    result: 'Salle complete'
  },
  {
    id: 3,
    name: 'Panozzi',
    slug: 'pannozi',
    category: 'Restaurant',
    url: 'https://panozzi.e-application.fr',
    screenshot: '/screenshots/panozzi.png',
    description: 'Pizzeria italienne avec commande en ligne',
    result: '+30% CA en ligne'
  },
  {
    id: 4,
    name: 'Monaco Bar',
    slug: 'monaco-bar',
    category: 'Bar',
    url: 'https://monaco-bar.e-application.fr',
    screenshot: '/screenshots/monaco-bar.png',
    description: 'Bar lounge avec reservation VIP',
    result: 'x2 reservations'
  },
  {
    id: 5,
    name: 'Danny Attali Clinic',
    slug: 'danny-attali-clinic',
    category: 'Esthetique',
    url: 'https://dannyattali.e-application.fr',
    screenshot: '/screenshots/danny-attali.png',
    description: 'Clinique esthetique haut de gamme',
    result: '+50% RDV en ligne'
  },
  {
    id: 6,
    name: 'AJ Barber',
    slug: 'aj-barber',
    category: 'Barbier',
    url: 'https://ajbarber.e-application.fr',
    screenshot: '/screenshots/aj-barber.png',
    description: 'Barbershop avec prise de RDV',
    result: 'Agenda rempli'
  },
  {
    id: 7,
    name: 'Hainan Chicken Rice',
    slug: 'hainan-chicken-rice',
    category: 'Restaurant',
    url: 'https://hainan-chicken-rice.e-application.fr',
    screenshot: '/screenshots/hainan.png',
    description: 'Restaurant asiatique click & collect',
    result: '+25% commandes'
  },
  {
    id: 8,
    name: 'ILYIF',
    slug: 'ilyif',
    category: 'Commerce',
    url: 'https://ilyif.e-application.fr',
    screenshot: '/screenshots/ilyif.png',
    description: 'Boutique en ligne avec fidelisation',
    result: 'Clients x3'
  }
];

function Home() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch('/api/categories')
      .then(r => r.json())
      .then(data => setCategories(data))
      .catch(err => console.error(err));
  }, []);

  // Icons SVG
  const icons = {
    calendar: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
    users: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    globe: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
    chart: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
    check: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>,
    arrow: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
  };

  return (
    <div className="home">
      <Helmet>
        <title>E-Shops Connect | Solutions Digitales pour Commerces</title>
        <meta name="description" content="Decouvrez comment les commerces boostent leur activite grace au digital. Reservations, fidelisation, visibilite." />
      </Helmet>

      {/* Hero Section */}
      <section className="hero">
        <div className="container hero-container">
          <div className="hero-content">
            <div className="hero-badge">Solutions digitales sur mesure</div>
            <h1>Transformez votre commerce avec le <span className="gradient-text">digital</span></h1>
            <p className="hero-subtitle">
              Reservations en ligne, fidelisation, visibilite accrue. 
              Rejoignez les commerces qui ont fait le choix de la modernite.
            </p>
            <div className="hero-buttons">
              <Link to="/categories" className="btn btn-primary">
                Voir les realisations
                <span className="btn-icon">{icons.arrow}</span>
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                Discuter de mon projet
              </Link>
            </div>
            <div className="trust-badges">
              <div className="trust-item">
                <span className="trust-icon">{icons.check}</span>
                <span>+50 commerces</span>
              </div>
              <div className="trust-item">
                <span className="trust-icon">{icons.check}</span>
                <span>11 ans d'experience</span>
              </div>
            </div>
          </div>
          
          {/* Phone Mockup */}
          <div className="hero-mockup">
            <div className="phone-frame">
              <div className="phone-notch"></div>
              <div className="phone-screen">
                <img src={realClients[0].screenshot} alt={realClients[0].name} />
              </div>
            </div>
            
            {/* Notifications */}
            <div className="notification notification-1">
              <div className="notif-icon notif-success">{icons.check}</div>
              <div className="notif-content">
                <strong>Nouvelle reservation</strong>
                <span>Marie D. - 14h30</span>
              </div>
            </div>
            
            <div className="notification notification-2">
              <div className="notif-icon notif-info">{icons.users}</div>
              <div className="notif-content">
                <strong>+23% clients</strong>
                <span>Ce mois-ci</span>
              </div>
            </div>
            
            <div className="notification notification-3">
              <div className="notif-icon notif-warning">{icons.chart}</div>
              <div className="notif-content">
                <strong>CA en hausse</strong>
                <span>+15%</span>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-bg-gradient"></div>
        <div className="hero-bg-pattern"></div>
      </section>

      {/* Showcase Section */}
      <section className="section showcase-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Nos realisations en production</h2>
            <p className="section-subtitle">Des sites et applications qui tournent au quotidien</p>
          </div>
          
          <div className="showcase-grid">
            {realClients.slice(0, 6).map((client) => (
              <div key={client.id} className="showcase-item">
                <div className="showcase-phone">
                  <div className="phone-frame-small">
                    <div className="phone-screen-small">
                      <img src={client.screenshot} alt={client.name} />
                    </div>
                  </div>
                  <div className="showcase-result">
                    <span>{client.result}</span>
                  </div>
                </div>
                <div className="showcase-info">
                  <span className="showcase-category">{client.category}</span>
                  <h3>{client.name}</h3>
                  <p>{client.description}</p>
                  <a href={client.url} target="_blank" rel="noopener noreferrer" className="showcase-link">
                    Voir le site {icons.arrow}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="section benefits-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Ce que le digital apporte</h2>
            <p className="section-subtitle">Des resultats concrets et mesurables</p>
          </div>
          
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">{icons.calendar}</div>
              <h3>Reservations 24/7</h3>
              <p>Vos clients reservent quand ils veulent. Fini les appels manques.</p>
              <div className="benefit-stat">
                <span className="stat-value">+40%</span>
                <span className="stat-label">de reservations</span>
              </div>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">{icons.users}</div>
              <h3>Fidelisation client</h3>
              <p>Programme fidelite digital. Vos clients cumulent et reviennent.</p>
              <div className="benefit-stat">
                <span className="stat-value">2x</span>
                <span className="stat-label">plus de retours</span>
              </div>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">{icons.globe}</div>
              <h3>Visibilite en ligne</h3>
              <p>Un site a votre image, visible sur Google.</p>
              <div className="benefit-stat">
                <span className="stat-value">x3</span>
                <span className="stat-label">plus de visites</span>
              </div>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">{icons.chart}</div>
              <h3>Pilotage temps reel</h3>
              <p>Tableau de bord clair pour les bonnes decisions.</p>
              <div className="benefit-stat">
                <span className="stat-value">-60%</span>
                <span className="stat-label">de no-shows</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* More Projects */}
      <section className="section more-projects-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Tous nos projets</h2>
          </div>
          <div className="projects-scroll">
            {realClients.map((client) => (
              <a key={client.id} href={client.url} target="_blank" rel="noopener noreferrer" className="project-mini">
                <div className="project-mini-screen">
                  <img src={client.screenshot} alt={client.name} />
                </div>
                <span className="project-mini-name">{client.name}</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="cta-content">
              <h2>Pret a digitaliser votre commerce ?</h2>
              <p>Premier echange gratuit et sans engagement.</p>
              <div className="cta-buttons">
                <Link to="/contact" className="btn btn-white">
                  Prendre rendez-vous
                  <span className="btn-icon">{icons.arrow}</span>
                </Link>
                <a href="tel:+33743678501" className="btn btn-outline">
                  07 43 67 85 01
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
